function handleResponse(response) {
    if (!response.ok) {
        const error = { status: response.status, statusText: response.statusText };
        return Promise.reject(error);
    }
    try {
        if (response.status === 204) {
            return Promise.resolve();
        }
        return response.json().then((json) => json);
    }
    catch (_a) {
        return Promise.resolve();
    }
}
export function fetchWrapper(path, options) {
    const { method, headers, query, signal } = options;
    const reqOptions = { method, headers };
    if (signal) {
        reqOptions.signal = signal;
    }
    if (method === 'POST' || method === 'PATCH') {
        const { body } = options;
        if (typeof body === 'object') {
            reqOptions.body = JSON.stringify(body);
            reqOptions.headers = Object.assign(Object.assign({}, reqOptions.headers), { 'Content-Type': 'application/json' });
        }
    }
    const queryParams = query ? new URLSearchParams(query).toString() : '';
    return fetch(`${path}${queryParams ? `?${queryParams}` : ''}`, reqOptions).then((response) => handleResponse(response));
}
//# sourceMappingURL=fetchWrapper.js.map